<script>
export default {
  data() {
    return {
      isVisible: false,
    };
  },
  methods: {
    toggleSwitcher() {
      this.isVisible = !this.isVisible;
    },

    /**
     * Onclick color change
     * @param theme theme color
     */
    setTheme(theme) {
      document
        .getElementById("color-opt")
        .setAttribute("href", "./css/colors/" + theme + ".css");
    },
  },
};
</script>


<template>
  <div>
    <!--START FOOTER-->
    <footer class="footer">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 margin-t-20">
            <h4>ILIMITADA TV</h4>
            <div class="text-muted margin-t-20">
              <ul class="list-unstyled footer-list">
                <li>
                  <a v-scroll-to="'#home'" href="javascript: void(0);">Home</a>
                </li>
                <li>
                  <a v-scroll-to="'#services'" href="javascript: void(0);" >Por que contratar?</a>
                </li>
                <li>
                  <a v-scroll-to="'#features'" href="javascript: void(0);" >Atendimento Humanizado</a>
                </li>
                <li>
                  <a v-scroll-to="'#pricing'" href="javascript: void(0);" >Planos</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-3 margin-t-20">
            <h4>Tutoriais | Smarphones</h4>
            <div class="text-muted margin-t-20">
              <ul class="list-unstyled footer-list">
                <li>
                  <a  @click="emBreve">Acessar no Celular Android</a>
                </li>
                <li>
                  <a  @click="emBreve">Acessar no Celular iOS</a>
                </li>
                <li>
                  <a  @click="emBreve">Acessar no ChromeCast</a>
                </li>

              </ul>
            </div>
          </div>
          <div class="col-lg-3 margin-t-20">
            <h4>Tutoriais | TVs</h4>
            <div class="text-muted margin-t-20">
              <ul class="list-unstyled footer-list">
                <li>
                  <a  @click="emBreve">Acessar em TV Box Android</a>
                </li>
                <li>
                  <a  @click="emBreve">Acessar na SmartTV LG</a>
                </li>
                <li>
                  <a  @click="emBreve">Acessar na SmartTV Philips</a>
                </li>
                <li>
                  <a  @click="emBreve">Acessar na SmartTV TCL</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-3 margin-t-20">
            <h4>Tutoriais | PC</h4>
            <div class="text-muted margin-t-20">
              <ul class="list-unstyled footer-list">
                <li>
                  <a  @click="emBreve">Acessar em TV Box Android</a>
                </li>
                <li>
                  <a  @click="emBreve">Acessar no Windows</a>
                </li>
                <li>
                  <a  @click="emBreve">Acessar no MAC</a>
                </li>
                <li>
                  <a @click="emBreve">Acessar no Linux</a>
                </li>
              </ul>
            </div>
            </div>
        </div>
      </div>
    </footer>
    <!--END FOOTER-->

    <!--START FOOTER ALTER-->
    <div class="footer-alt">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="float-left pull-none">
              <p class="copy-rights text-muted">2019-{{ new Date().getFullYear()}} © Todos os direitos reservados.</p>
            </div>
            <div class="float-right pull-none">
              <img src="@/assets/images/payment.png" alt="payment-img" height="36" />
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
    <!--START FOOTER ALTER-->
    <!-- Style switcher -->
    <!--
    <div id="style-switcher" :style="isVisible ? 'left: 0px' : 'left: -189px'">
      <div>
        <h3>Select your color</h3>
        <ul class="pattern">
          <li>
            <a class="color1" href="javascript: void(0);" v-on:click="setTheme('red')"></a>
          </li>
          <li>
            <a class="color2" href="javascript: void(0);" v-on:click="setTheme('green')"></a>
          </li>
          <li>
            <a class="color3" href="javascript: void(0);" v-on:click="setTheme('pink')"></a>
          </li>
          <li>
            <a class="color4" href="javascript: void(0);" v-on:click="setTheme('cyan')"></a>
          </li>
          <li>
            <a class="color5" href="javascript: void(0);" v-on:click="setTheme('purple')"></a>
          </li>
          <li>
            <a class="color6" href="javascript: void(0);" v-on:click="setTheme('blue')"></a>
          </li>
          <li>
            <a class="color7" href="javascript: void(0);" v-on:click="setTheme('orange')"></a>
          </li>
          <li>
            <a class="color8" href="javascript: void(0);" v-on:click="setTheme('yellow')"></a>
          </li>
        </ul>
      </div>
      <div class="bottom">
        <a href="javascript: void(0);" class="settings" @click="toggleSwitcher()">
          <i class="mdi mdi-settings mdi-spin"></i>
        </a>
      </div>
    </div> -->
    <!-- end Style switcher -->
  </div>
</template>

<script>
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'

export default {
  methods: {

    emBreve: function(){
     
     Swal.fire({
       title: 'Tente novamente daqui uns dias...', 
       text: 'Nesse momento esse tutorial está sendo atualizado e está indisponível no site.'
     })

    }

  }
}
</script>